import Button from '../../components/bootstrap/Button';
import Card, { CardBody, CardFooter, CardHeader } from '../../components/bootstrap/Card';
import Icon from '../../components/icon/Icon';
import Page from '../../layout/Page/Page';
import PageWrapper from '../../layout/PageWrapper/PageWrapper';

const PricingPage = () => {
	return (
		<PageWrapper title='Pricing' isProtected={false}>
			<Page>
				<div id='second' className='row scroll-margin'>
					<div className='col-12 mb-3'>
						<div className='display-4 fw-bold py-3'>Pricing</div>
					</div>

					<div className='col-md-4'>
						<Card stretch>
							<CardHeader borderSize={1}>
								<div className='col text-center py-4'>
									<h2 className='fw-bold display-5'>Starter Plan</h2>
									<div className='h5 fw-light'>
										For small sellers just getting started.
									</div>
								</div>
							</CardHeader>
							<CardBody>
								<div className='row pt-5 g-4 align-items-center'>
									<div className='col-12'>
										<h3 className='display-1 fw-bold text-center'>
											<span className='display-4 fw-bold'>$</span>19
											<span className='display-6'>/month</span>
										</h3>
									</div>
									<div className='col-12'>
										<div className='lead'>
											<Icon icon='Done Outline' color='success' /> Number of
											stores : 5
										</div>
										<div className='lead'>
											<Icon icon='Done Outline' color='success' /> Up to 100
											product listings/month
										</div>
										<div className='lead text-muted'>
											<Icon icon='Done Outline' color='success' /> Order
											management
										</div>
										<div className='lead text-muted'>
											<Icon icon='Done Outline' color='success' /> Inventory
											management
										</div>
									</div>
								</div>
							</CardBody>
							<CardFooter borderSize={1}>
								<div className='col-12'>
									<Button
										color='warning'
										isLight
										className='w-100 py-3 text-uppercase'
										size='lg'>
										Select Plan
									</Button>
								</div>
							</CardFooter>
						</Card>
					</div>
					<div className='col-md-4'>
						<Card stretch>
							<CardHeader borderSize={1}>
								<div className='col text-center py-4'>
									<h2 className='fw-bold display-5'>Growth Plan</h2>
									<div className='h5 fw-light'>For growing online stores.</div>
								</div>
							</CardHeader>
							<CardBody>
								<div className='row pt-5 g-4 align-items-center'>
									<div className='col-12'>
										<h3 className='display-1 fw-bold text-center'>
											<span className='display-4 fw-bold'>$</span>59
											<span className='display-6'>/month</span>
										</h3>
									</div>
									<div className='col-12'>
										<div className='lead'>
											<Icon icon='Done Outline' color='success' /> Number of
											stores : 10
										</div>
										<div className='lead'>
											<Icon icon='Done Outline' color='success' /> Up to 1,000
											product listings/month
										</div>
										<div className='lead'>
											<Icon icon='Done Outline' color='success' /> Bulk
											listing upload tools
										</div>
										<div className='lead'>
											<Icon icon='Done Outline' color='success' /> Bulk
											shipment upload tools
										</div>
										<div className='lead'>
											<Icon icon='Done Outline' color='success' /> Advanced,
											customizable templates
										</div>
										<div className='lead'>
											<Icon icon='Done Outline' color='success' /> Priority
											email + chat support
										</div>
									</div>
								</div>
							</CardBody>
							<CardFooter borderSize={1}>
								<div className='col-12'>
									<Button
										color='warning'
										isLight
										className='w-100 py-3 text-uppercase'
										size='lg'>
										Select Plan
									</Button>
								</div>
							</CardFooter>
						</Card>
					</div>
					<div className='col-md-4'>
						<Card stretch>
							<CardHeader borderSize={1}>
								<div className='col text-center py-4'>
									<h2 className='fw-bold display-5'>Pro Plan</h2>
									<div className='h5 fw-light'>
										For established sellers managing large catalogs.
									</div>
								</div>
							</CardHeader>
							<CardBody>
								<div className='row pt-5 g-4 align-items-center'>
									<div className='col-12'>
										<h3 className='display-1 fw-bold text-center'>
											<span className='display-4 fw-bold'>$</span>149
											<span className='display-6'>/month</span>
										</h3>
									</div>
									<div className='col-12'>
										<div className='lead'>
											<Icon icon='Done Outline' color='success' /> Number of
											stores : unlimited
										</div>
										<div className='lead'>
											<Icon icon='Done Outline' color='success' /> Unlimited
											product listings
										</div>
										<div className='lead'>
											<Icon icon='Done Outline' color='success' /> Premium
											design templates
										</div>
										<div className='lead'>
											<Icon icon='Done Outline' color='success' /> Full
											automation for orders & messaging
										</div>
										<div className='lead'>
											<Icon icon='Done Outline' color='success' /> Analytics &
											reporting dashboard
										</div>
										<div className='lead'>
											<Icon icon='Done Outline' color='success' /> Dedicated
											account manager / priority support
										</div>
									</div>
								</div>
							</CardBody>
							<CardFooter borderSize={1}>
								<div className='col-12'>
									<Button
										color='warning'
										isLight
										className='w-100 py-3 text-uppercase'
										size='lg'>
										Select Plan
									</Button>
								</div>
							</CardFooter>
						</Card>
					</div>
				</div>
				<div className='col-12 d-flex flex-column justify-content-center align-items-center mb-4'>
					<Button
						className='px-5 py-3'
						color='primary'
						isLight
						icon='HolidayVillage'
						tag='a'
						href='/'>
						Homepage
					</Button>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default PricingPage;
